// extracted by mini-css-extract-plugin
module.exports = {"prose":"InfoContent_prose__bxkl_"};